module.exports = __webpack_public_path__ + "img/south_korea.3218e79.webp";